import cx from "classnames";

import styles from "./OfferBadge.module.scss";

type OfferBadgeVariant = "period" | "savings";

export interface OfferBadgeProps {
  children: React.ReactNode;
  variant?: OfferBadgeVariant;
  className?: string;
}

export const OfferBadge = ({
  children,
  variant = "period",
  className,
}: OfferBadgeProps) => {
  return (
    <span className={cx(styles.badge, styles[variant], className)}>
      {children}
    </span>
  );
};

export default OfferBadge;
